<template>
  <PowerBIReportViewer
    :current-requester="CURRENT_REQUESTER"
    page-title="PBI Marca Test"
    page-subtitle="Select workspace and reports"
    brand-label="Brand"
    @workspace-changed="handleWorkspaceChange"
    @report-changed="handleReportChange"
    @brand-changed="handleBrandChange"
  />
</template>

<script setup>
import PowerBIReportViewer from "@/components/powerbi/powerbiReportViewer.vue";

const CURRENT_REQUESTER = "test";

const handleWorkspaceChange = data => {
  console.log("Workspace changed:");
};

const handleReportChange = data => {
  console.log("Report changed:");
};

const handleBrandChange = data => {
  console.log("Brand changed:");
};
</script>
